export default "/videos/8d9c9adb359cfaa7a1d3bebf28615c0a.mp4";